module.exports = __webpack_public_path__ + "static/img/1-17.abeac61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/1-17.png
// module id = hW3T
// module chunks = 15